import React, {useEffect, useState} from 'react';
import {Card, Col, Row, Table} from "react-bootstrap";
import dayjs from "dayjs";
import Flex from "../../../common/Flex";
import {useDispatch, useSelector} from "react-redux";
import {
    selectDateDayJSFormat,
    selectLang,
    Translate, updateShowInProgressAsync,
} from '../../../../app/store/reducers/main/mainReducer';
import SoftBadge from "../../../common/SoftBadge";
import {EmpowermentV2Wrapper, ExecutorDeclined, PersonDeclined} from "../../../../enum/EmpowermentV2Status";
import CustomerCancelEmpowermentV2                            from "./CustomerCancelEmpowermentV2";
import {selectActiveOrganization}                             from "../../../../app/store/reducers/auth/authReducer";
import PersonAcceptEmpowermentV2   from "./PersonAcceptEmpowermentV2";
import ExecutorAcceptEmpowermentV2  from "./ExecutorAcceptEmpowermentV2";
import PersonDeclineEmpowermentV2   from "./PersonDeclineEmpowermentV2";
import ExecutorDeclineEmpowermentV2 from "./ExecutorDeclineEmpowermentV2";
import SyncEmpowermentV2            from "./SyncEmpowermentV2";
import WarningAlert                 from "../components/WarningAlert";
import EventBus from "../../../../app/eventbus/EventBus";
import {
    CUSTOMER_CANCEL_EMPOWERMENT_V2_FAILED,
    CUSTOMER_CANCEL_EMPOWERMENT_V2_SUCCESS,
    EMPOWERMENT_V2_SEND_FAILED,
    EMPOWERMENT_V2_SEND_REQUESTED,
    EMPOWERMENT_V2_SEND_SUCCESS,
    EXECUTOR_ACCEPT_EMPOWERMENT_V2_FAILED,
    EXECUTOR_ACCEPT_EMPOWERMENT_V2_SUCCESS,
    EXECUTOR_DECLINE_EMPOWERMENT_V2_FAILED,
    EXECUTOR_DECLINE_EMPOWERMENT_V2_SUCCESS,
    PERSON_ACCEPT_EMPOWERMENT_V2_FAILED,
    PERSON_ACCEPT_EMPOWERMENT_V2_SUCCESS,
    PERSON_DECLINE_EMPOWERMENT_V2_FAILED,
    PERSON_DECLINE_EMPOWERMENT_V2_SUCCESS,
    SYNC_EMPOWERMENT_V2_FAILED,
    SYNC_EMPOWERMENT_V2_SUCCESS
} from "../../../../app/eventbus/roaming/roamingEmpowermentV2Events";
import {loadMeasurementsAsync, selectMeasurements} from "../../../../app/store/reducers/roaming/roamingReducer";
import IconButton from "../../../common/IconButton";
import {Link, useHistory} from "react-router-dom";
import SelectCertificateWrapperComponent from "../components/SelectCertificateWrapperComponent";
import {faClone, faSignature} from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";
import {selectCurrentCertificate} from "../../../../app/store/reducers/eimzo/eimzoReducer";
import {useParams} from "react-router";
import {sendEmpowermentV2Async}            from "../../../../app/store/reducers/roaming/roamingEmpowermentV2Reducer";
import PrintEmpowermentV2                from "./PrintEmpowermentV2";
import {getOrganizationBillingInfoAsync} from "../../../../app/store/reducers/billing/billingReducer";
import checkPermission from "../../../../enum/Permission/CheckPermission";
import {
    PermissionRoamingEmpowermentV2Accept,
    PermissionRoamingEmpowermentV2Update
} from "../../../../enum/Permission/RoamingPermission";
import toastPermission from "../../../../enum/Permission/ToastPermission";

const EmpowermentV2 = ({empowermentV2, draftEmpowermentV2Json, modalId}) => {
    const dateFormat = useSelector(selectDateDayJSFormat);
    const lang = useSelector(selectLang);
    const t = Translate;
    const activeOrganization = useSelector(selectActiveOrganization);
    const empowermentV2Wrapper = new EmpowermentV2Wrapper(empowermentV2);
    const [eventMessage, setEventMessage] = useState(null);
    const measurements = useSelector(selectMeasurements)
    const dispatch = useDispatch()
    const currentCertificate = useSelector(selectCurrentCertificate);
    const {id} = useParams();
    const history = useHistory();


    const allowCustomerCancel = empowermentV2Wrapper.allowCustomerCancel(activeOrganization.inn, activeOrganization.pinfl);
    const allowPersonAccept = empowermentV2Wrapper.allowPersonAccept(activeOrganization.inn, activeOrganization.pinfl);
    const allowPersonDecline = empowermentV2Wrapper.allowPersonDecline(activeOrganization.inn, activeOrganization.pinfl);
    const allowExecutorAccept = empowermentV2Wrapper.allowExecutorAccept(activeOrganization.inn, activeOrganization.pinfl);
    const allowExecutorDecline = empowermentV2Wrapper.allowExecutorDecline(activeOrganization.inn, activeOrganization.pinfl);
    const allowCopy = empowermentV2Wrapper.allowCustomerCopy(activeOrganization.inn, activeOrganization.pinfl);
    const allowSync = empowermentV2Wrapper.allowSync();
    const showDeclineNotes = PersonDeclined === empowermentV2.status || ExecutorDeclined === empowermentV2.status

    useEffect(() => {
        dispatch(loadMeasurementsAsync(lang));
        //success
        const onCustomerCancelEmpowermentV2SuccessHandler = EventBus.on(CUSTOMER_CANCEL_EMPOWERMENT_V2_SUCCESS, () => {
            setEventMessage({
                variant: 'success',
                title: t(lang, 'roaming.empowerment.alert.success_event_title'),
                text: t(lang, 'roaming.empowerment.alert.empowerment_cancel_success')
            });
        })

        const onPersonAcceptEmpowermentV2SuccessHandler = EventBus.on(PERSON_ACCEPT_EMPOWERMENT_V2_SUCCESS, () => {
            dispatch(getOrganizationBillingInfoAsync());
            setEventMessage({
                variant: 'success',
                title: t(lang, 'roaming.empowerment.alert.success_event_title'),
                text: t(lang, 'roaming.empowerment.alert.empowerment_accept_success')
            });
        })

        const onPersonDeclineEmpowermentV2SuccessHandler = EventBus.on(PERSON_DECLINE_EMPOWERMENT_V2_SUCCESS, () => {
            setEventMessage({
                variant: 'success',
                title: t(lang, 'roaming.empowerment.alert.success_event_title'),
                text: t(lang, 'roaming.empowerment.alert.empowerment_decline_success')
            });
        })

        const onExecutorAcceptEmpowermentV2SuccessHandler = EventBus.on(EXECUTOR_ACCEPT_EMPOWERMENT_V2_SUCCESS, () => {
            dispatch(getOrganizationBillingInfoAsync());
            setEventMessage({
                variant: 'success',
                title: t(lang, 'roaming.empowerment.alert.success_event_title'),
                text: t(lang, 'roaming.empowerment.alert.empowerment_accept_success')
            });
        })

        const onExecutorDeclineEmpowermentV2SuccessHandler = EventBus.on(EXECUTOR_DECLINE_EMPOWERMENT_V2_SUCCESS, () => {
            setEventMessage({
                variant: 'success',
                title: t(lang, 'roaming.empowerment.alert.success_event_title'),
                text: t(lang, 'roaming.empowerment.alert.empowerment_decline_success')
            });
        })

        const onSyncEmpowermentV2SuccessHandler = EventBus.on(SYNC_EMPOWERMENT_V2_SUCCESS, () => {
            setEventMessage({
                variant: 'success',
                title: t(lang,'roaming.empowerment.alert.success_event_title'),
                text: t(lang,'roaming.empowerment.alert.empowerment_sync_success')
            });
        })

        //fail
        const onCustomerCancelEmpowermentV2FailedHandler = EventBus.on(CUSTOMER_CANCEL_EMPOWERMENT_V2_FAILED, (error) => {
            setEventMessage({
                variant: 'danger',
                title: t(lang,'roaming.empowerment.alert.failed_event_title'),
                text: error.message
            });
        })

        const onPersonAcceptEmpowermentV2FailedHandler = EventBus.on(PERSON_ACCEPT_EMPOWERMENT_V2_FAILED, (error) => {
            setEventMessage({
                variant: 'danger',
                title: t(lang,'roaming.empowerment.alert.failed_event_title'),
                text: error.message
            });
        })

        const onPersonDeclineEmpowermentV2FailedHandler = EventBus.on(PERSON_DECLINE_EMPOWERMENT_V2_FAILED, (error) => {
            setEventMessage({
                variant: 'danger',
                title: t(lang,'roaming.empowerment.alert.failed_event_title'),
                text: error.message
            })
        })

        const onExecutorAcceptEmpowermentV2FailedHandler = EventBus.on(EXECUTOR_ACCEPT_EMPOWERMENT_V2_FAILED, (error) => {
            setEventMessage({
                variant: 'danger',
                title: t(lang,'roaming.empowerment.alert.failed_event_title'),
                text: error.message
            });
        })

        const onExecutorDeclineEmpowermentV2FailedHandler = EventBus.on(EXECUTOR_DECLINE_EMPOWERMENT_V2_FAILED, (error) => {
            setEventMessage({
                variant: 'danger',
                title: t(lang,'roaming.empowerment.alert.failed_event_title'),
                text: error.message
            });
        })

        const onSendEmpowermentV2RequestedHandler = EventBus.on(EMPOWERMENT_V2_SEND_REQUESTED, () => {
            dispatch(updateShowInProgressAsync(true))
        })

        const onSendEmpowermentV2SuccessHandler = EventBus.on(EMPOWERMENT_V2_SEND_SUCCESS, () => {
            toast.success(t(lang, "edi.common.toast.success"))
            history.push(`/roaming/empowermentV2/${modalId ? modalId : id}`)
            dispatch(updateShowInProgressAsync(false))
        })

        const onSendEmpowermentV2FailedHandler = EventBus.on(EMPOWERMENT_V2_SEND_FAILED, () => {
            toast.error(t(lang, "edi.common.toast.error"))
            dispatch(updateShowInProgressAsync(false))
        })

        const onSyncEmpowermentV2FailedHandler = EventBus.on(SYNC_EMPOWERMENT_V2_FAILED, (error) => {
            setEventMessage({
                variant: 'danger',
                title: t(lang, 'roaming.empowerment.alert.failed_event_title'),
                text: error.message
            });
        })

        return () => {
            EventBus.remove(CUSTOMER_CANCEL_EMPOWERMENT_V2_SUCCESS, onCustomerCancelEmpowermentV2SuccessHandler);
            EventBus.remove(PERSON_ACCEPT_EMPOWERMENT_V2_SUCCESS, onPersonAcceptEmpowermentV2SuccessHandler);
            EventBus.remove(PERSON_DECLINE_EMPOWERMENT_V2_SUCCESS, onPersonDeclineEmpowermentV2SuccessHandler);
            EventBus.remove(EXECUTOR_ACCEPT_EMPOWERMENT_V2_SUCCESS, onExecutorAcceptEmpowermentV2SuccessHandler);
            EventBus.remove(EXECUTOR_DECLINE_EMPOWERMENT_V2_SUCCESS, onExecutorDeclineEmpowermentV2SuccessHandler);

            EventBus.remove(CUSTOMER_CANCEL_EMPOWERMENT_V2_FAILED, onCustomerCancelEmpowermentV2FailedHandler);
            EventBus.remove(PERSON_ACCEPT_EMPOWERMENT_V2_FAILED, onPersonAcceptEmpowermentV2FailedHandler);
            EventBus.remove(PERSON_DECLINE_EMPOWERMENT_V2_FAILED, onPersonDeclineEmpowermentV2FailedHandler);
            EventBus.remove(EXECUTOR_ACCEPT_EMPOWERMENT_V2_FAILED, onExecutorAcceptEmpowermentV2FailedHandler);
            EventBus.remove(EXECUTOR_DECLINE_EMPOWERMENT_V2_FAILED, onExecutorDeclineEmpowermentV2FailedHandler);

            EventBus.remove(EMPOWERMENT_V2_SEND_REQUESTED, onSendEmpowermentV2RequestedHandler)
            EventBus.remove(EMPOWERMENT_V2_SEND_SUCCESS, onSendEmpowermentV2SuccessHandler)
            EventBus.remove(EMPOWERMENT_V2_SEND_FAILED, onSendEmpowermentV2FailedHandler)

            EventBus.remove(SYNC_EMPOWERMENT_V2_SUCCESS, onSyncEmpowermentV2SuccessHandler);
            EventBus.remove(SYNC_EMPOWERMENT_V2_FAILED, onSyncEmpowermentV2FailedHandler)
        }
    }, [])

    const getMeasure = measurementId => {
        return measurements.find(x => x.measureId === measurementId) || null
    }

    const signEmpowermentV2 = () => {
        sendEmpowermentV2Async(currentCertificate, lang, draftEmpowermentV2Json)
            .then(response => {})
            .catch(error => {})
    }


    return (
        <>
            {eventMessage && <WarningAlert text={eventMessage.text} title={eventMessage.title} variant={eventMessage.variant}/>}

            {!eventMessage && empowermentV2?.roaming_error && <WarningAlert text={empowermentV2?.roaming_error.message} title={'Ошибка от роуминга'} variant={'danger'}/>}
            <Card className="my-3 p-3">
                <Row>
                    <h3 className="text-600 ms-2 col-8">{t(lang,"edi.common.created.time")}: {empowermentV2.created_at}</h3>
                    {empowermentV2.status &&
                        <Col className="text-end">
                            <span className="me-2">{t(lang, 'roaming.empowerment.status')}:</span>
                            <SoftBadge pill className="fs--2" bg={empowermentV2Wrapper.GetStatusBadgeVariant(activeOrganization.inn, activeOrganization.pinfl)}>
                                {t(lang, empowermentV2Wrapper.GetStatusTranslationKey(activeOrganization.inn, activeOrganization.pinfl))}
                            </SoftBadge>

                        </Col>
                    }
                </Row>
                <Row className="mt-3 d-flex">
                    <Col xs={12} md={6}>
                        {allowCopy &&
                            <IconButton
                                variant="falcon-primary"
                                size="sm"
                                icon={faClone}
                                as={Link}
                                to={`/roaming/empowerment-v2/actions/${empowermentV2.id}?status=${empowermentV2?.status || null}`}
                                className="mx-2 d-inline"
                        >
                            {t(lang, "roaming.common.copy")}
                        </IconButton>}

                        {
                            empowermentV2.status ?
                                <>
                                    {allowSync && <SyncEmpowermentV2 className="mx-2" id={empowermentV2.id}/>}
                                    {allowCustomerCancel && <CustomerCancelEmpowermentV2 className="mx-2" id={empowermentV2.id}/>}
                                    {allowPersonDecline && <PersonDeclineEmpowermentV2 className="mx-2" id={empowermentV2.id} />}
                                    {allowPersonAccept && <PersonAcceptEmpowermentV2 className="mx-2" id={empowermentV2.id}/>}
                                    {allowExecutorDecline && <ExecutorDeclineEmpowermentV2 className="mx-2" id={empowermentV2.id}/>}
                                    {allowExecutorAccept && <ExecutorAcceptEmpowermentV2 className="mx-2" id={empowermentV2.id} />}
                                    <PrintEmpowermentV2 id={empowermentV2.id} />
                                </>
                                :
                                <>
                                    <IconButton
                                        variant="falcon-warning"
                                        size="sm"
                                        icon={'edit'}
                                        iconClassName="me-1"
                                        type="submit"
                                        as={dispatch(checkPermission(PermissionRoamingEmpowermentV2Update)) ? Link : 'div'}
                                        onClick={()=>!dispatch(checkPermission(PermissionRoamingEmpowermentV2Update)) && dispatch(toastPermission())}
                                        to={`/roaming/empowerment-v2/draft-edit/${modalId ? modalId : id}`}
                                    >{t(lang,"edi.common.button.edit")}</IconButton>
                                    <SelectCertificateWrapperComponent permission={PermissionRoamingEmpowermentV2Accept}
                                        submitButton={
                                            <IconButton onClick={signEmpowermentV2} id="sendButton" size="sm" className="mx-2" transform="shrink-3" variant="falcon-primary" icon={faSignature}>
                                                {t(lang, 'roaming.common.send')}
                                            </IconButton>
                                        }
                                        openDialogButtonText={t(lang, 'roaming.act_form_send')}
                                    />
                                </>
                        }
                    </Col>
                </Row>
            </Card>


            <Card className="p-3">
                <Row className="d-flex flex-lg-row flex-column">
                    <Col xs={12} xl={3} className="d-flex flex-column">
                        <h5 className="fw-bold mb-1">{t(lang, 'edi.common.label.organization')}</h5>
                        <span><b>{t(lang, 'edi.common.label.inn')}:</b> {empowermentV2.customer.inn}</span>
                    </Col>

                    <Col xs={12} xl={3} className="d-flex flex-column my-3 my-xl-0">
                        <h5 className="fw-bold mb-1">{t(lang, 'edi.common.contractor')}</h5>
                        <span><b>{t(lang, 'edi.common.label.inn')}:</b> {empowermentV2.executor.inn}</span>
                    </Col>

                    <Col xs={12} xl={3} className="d-flex flex-column">
                        <h5 className="fw-bold mb-1">{t(lang, 'edi.attorney.issued_by')}</h5>
                        <span><b>{t(lang, 'edi.common.label.inn')}:</b> {empowermentV2.person_info.person_inn}</span>
                    </Col>

                    {/*<Col xs={3} lg={2} className="border border-black">*/}
                    {/*    QR CODE*/}
                    {/*</Col>*/}
                </Row>
            </Card>

            <Card className="my-3">
                <Card.Header>
                    <Row className="d-flex flex-column flex-lg-row align-items-md-center justify-content-lg-between">
                        <Col xs={12} md={8} lg={5} className="d-flex justify-content-center justify-content-lg-start">
                            <h5 className="p-0 ms-3"><b className="pe-1">{t(lang,"edi.common.id")}:</b>{empowermentV2.id}</h5>
                        </Col>
                        <Col xs={12} md={8} lg={4}>
                            {showDeclineNotes &&
                                <div className="alert-danger p-1 text-center">
                                    <span className="fw-bold me-2">{t(lang, "roaming.common.comment")}:</span>
                                    <strong>{empowermentV2.notes}</strong>
                                </div>
                            }
                        </Col>
                    </Row>

                    <Row className="my-4">
                        <h3 className="text-center">{t(lang, 'edi.common.attorney')}: {empowermentV2.info.number}</h3>
                        <Col className="d-flex flex-column flex-md-row justify-content-around">
                            <div>
                                <p className="mb-1">
                                    <span className="fs-0 fw-bold mb-1">{t(lang, "edi.common.shipment.number")}: </span>
                                    <span>{empowermentV2.info.number}</span>
                                </p>
                                <p className="mb-1">
                                    <strong className="me-2">{t(lang, 'roaming.empowerment.start_date')}:</strong>
                                    <span>
                                    {dayjs(empowermentV2.info.start, 'YYYY-MM-DD').format(dateFormat)}
                                </span>
                                </p>
                                <p className="mb-1">
                                    <strong className="me-2">{t(lang, 'roaming.empowerment.end_date')}:</strong>
                                    <span>{dayjs(empowermentV2.info.end, 'YYYY-MM-DD').format(dateFormat)}</span>
                                </p>
                            </div>
                            <div className="mt-3 mt-md-0">
                                <p className="mb-1">
                                    <span className="fs-0 fw-bold">{t(lang, "edi.common.contract.number")}: </span>
                                    <span>{empowermentV2.contract.number}</span>
                                </p>
                                <p className="mb-1">
                                    <span className="fs-0 fw-bold">{t(lang, "edi.common.contract.date")}: </span>
                                    <span>{dayjs(empowermentV2.contract.date, "YYYY-MM-DD").format(dateFormat)}</span>
                                </p>
                            </div>
                        </Col>
                    </Row>


                    <Row className="align-items-center justify-content-center mb-5 flex-column flex-lg-row">
                        <Col xs={12} lg={6} className="align-items-center fs--1">
                            <div className="d-flex justify-content-between">
                                <b className="fs-1">{t(lang, 'edi.common.label.organization')}:</b>
                                <span className="col-8">{empowermentV2.customer.name} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <b className="col-4">{t(lang, 'roaming.common.inn')}:</b>
                                <span className="col-8">{empowermentV2.customer.inn} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <b className="col-4">{t(lang, 'roaming.common.director')}:</b>
                                <span className="col-8">{empowermentV2.customer.director} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <b className="col-4">{t(lang, 'roaming.common.accountant')}:</b>
                                <span className="col-8">{empowermentV2.customer.accountant} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                        </Col>
                        <Col xs={12} lg={6} className="align-items-center fs--1 my-4 my-lg-0">
                            <div className="d-flex justify-content-between">
                                <b className="fs-1">{t(lang, 'edi.common.contractor')}:</b>
                                <span className="col-8">{empowermentV2.executor.name} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <b className="col-4">{t(lang, 'roaming.common.inn')}:</b>
                                <span className="col-8">{empowermentV2.executor.inn} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <b className="col-4">{t(lang, 'roaming.common.director')}:</b>
                                <span className="col-8">{empowermentV2.executor.director} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <b className="col-4">{t(lang, 'roaming.common.accountant')}:</b>
                                <span className="col-8">{empowermentV2.executor.accountant} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                        </Col>
                        <Col xs={12} lg={8} className="align-items-center fs--1 mt-lg-4">
                            <div className="d-flex justify-content-between">
                                <b className="col-4 fs-1">{t(lang, 'roaming.empowerment.empowerment_person')}:</b>
                                <span className="col-8">{empowermentV2.person_info.full_name} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <b className="col-4">{t(lang, 'edi.common.label.inn')}:</b>
                                <span className="col-8">{empowermentV2.person_info.person_inn} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <b className="col-4">{t(lang, 'roaming.empowerment.contract_material_assets')}:</b>
                                <span className="col-8">{t(lang, 'roaming.empowerment.contact_info.from.contact_date', {contract_number: empowermentV2.contract.number, contract_date: dayjs(empowermentV2.contract.date, 'YYYY-MM-DD').format(dateFormat)})} <hr className="m-0" style={{height: "2px"}}/></span>
                            </div>
                        </Col>
                    </Row>

                </Card.Header>

                <Card.Footer>
                    <Flex justifyContent="center" className="mb-2">
                        <h6 className="fs-0">{t(lang, 'roaming.empowerment.items.title')}</h6>
                    </Flex>
                    <Table bordered responsive className="border-bottom fs--1 border-500">
                        <thead className="text-dark bg-200">
                        <tr>
                            <th className="text-center" rowSpan={2}>{t(lang, 'edi.attorney.data_table.product_number')}</th>
                            <th className="text-center">{t(lang, 'roaming.common.items.product')}</th>
                            <th className="text-center">{t(lang, 'roaming.common.items.catalog_class_code')}</th>
                            <th className="text-center">{t(lang, 'roaming.common.items.quantity')}</th>
                            <th className="text-center">{t(lang, 'roaming.common.items.measurement')}</th>
                        </tr>
                        <tr>
                            <th className="p-0 text-center">1</th>
                            <th className="p-0 text-center">2</th>
                            <th className="p-0 text-center">3</th>
                            <th className="p-0 text-center">4</th>
                        </tr>
                        </thead>
                        <tbody>
                        {empowermentV2.items.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center mb-0 text-nowrap fw-semi-bold">{item.name}</td>
                                    <td className="text-center">{item.catalog.code}</td>
                                    <td className="text-center">{item.quantity}</td>
                                    <td className="text-center">{getMeasure(item.measure_id)?.name}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </Table>
                </Card.Footer>
            </Card>
        </>
    );
};

export default EmpowermentV2;
